import React from "react";
import Immutable from "immutable";

export default function ChoicesCounter({
	currentInput,
}: {
	currentInput: Immutable.List<string>;
}) {
	if (currentInput.isEmpty()) {
		return null;
	}

	return (
		<span className="dropdown-choices-counter">{currentInput.size}</span>
	);
}
